import request from 'api/request';

export default function createEmailRoute(email) {
  return request({
    url: '/emails',
    method: 'POST',
    data: { email },
  });
}
